<template>
  <div class="equipment" v-if="showId === '2' || showId === '3' || showId === '6' || showId === '8'">
    <div class="eq-title">设备状态</div>
    <div class="eq-lists">
      <div class="eq-items" v-for="item in colDataList" :key="item.id">
        <p class="name">{{ item.sensorName }}</p>
        <p class="val">
          {{ item.valueList[0].textValue === '0' ? '关' : item.valueList[0].textValue === '1' ? '开' : item.valueList[0].textValue
          }}{{ item.valueList[0].unit }}</p
        >

        <!-- <el-switch
          v-if="item.type === 1"
          class="my-switch"
          :class="item.last_data ? 'active' : ''"
          v-model="item.last_data"
          @change="changeSwitch($event, item.id)"
        >
        </el-switch> -->
        <div class="controllable-box" v-if="item.isControllable === 1">
          <!-- <span class="span-button" @click="handleCommand(item.sensorCode, item.id)">开</span>
          <span class="span-button margin" @click="handleCommand(item.sensorCode, item.id)">关</span>
          <span class="span-button" @click="handleCommand(item.sensorCode, item.id)">停</span> -->
          <span class="span-button" @click="handleCommand(item.sensorCode, c.id)" v-for="(c, b) in item.commandList" :key="b">{{
            c.commandName
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleCommandApi } from '@/request/api'
export default {
  props: {
    showId: {
      type: String,
      default: ''
    },
    weatherCount: {
      type: Number,
      default: 0
    },
    colDataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    cameraList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    async handleCommand(sensorCode, commandId) {
      const res = await handleCommandApi({
        sensorCode,
        commandId
      })
      if (res.code === 200) {
        this.$notify({
          title: '成功',
          message: res.msg,
          type: 'success'
        })
      }
    },
    changeSwitch(e, id) {
      this.$emit('changeSwitch', e, id)
    }
  }
}
</script>

<style lang="less" scoped>
.equipment {
  width: 282px;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  border-top: 6px solid #125397;
  padding: 23px 13px;
  background-color: #0f243d;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 166px;
  left: 78px;
  z-index: 1999;
  transition: all 0.5s;
  p {
    margin: 0 0 10px 0;
    &:first-of-type {
      font-weight: bold;
      font-size: 18px;
      margin: 0 0 20px 0;
    }
  }
  .eq-title {
    color: #3e90e5;
    font-size: 16px;
    margin-bottom: 17px;
    text-align: center;
  }

  .eq-lists {
    display: flex;
    width: 100%;
    flex-direction: column;

    .eq-items {
      width: 100%;
      height: auto;
      min-height: 41px;
      background: rgba(62, 144, 229, 0.25);
      border: 1px solid #3e90e5;
      border-radius: 5px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 6px 6px;
      margin-bottom: 14px;

      .left-div {
        display: flex;
        align-items: center;
        .icon1-img {
          width: 30px;
          height: 30px;
          margin-right: 16px;
        }
      }
      .name,
      .val {
        font-size: 14px;
        color: #ccc;
        font-weight: normal;
        margin: 0;
      }
      .name {
        flex: 0 0 auto;
        max-width: 100%;
        margin-right: 8px;
        white-space: normal;
        word-break: break-word;
      }
      .val {
        flex: 1;
        min-width: 0;
        word-break: break-all;
        color: #fff;
        line-height: 1.4;
      }
      .controllable-box {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-left: 8px;
        white-space: nowrap;
        span {
          cursor: pointer;
          &:hover {
            color: #3e90e5;
          }
        }
        .span-button {
          margin-right: 4px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
